<template>
    <div class="w-full text-black">
        <div class="pb-[18px] border-b flex items-end justify-between">
            <div>
                <h2 class="text-[20px] font-light">Compétences</h2>
                <p class="text-[13px] font-extralight mt-2">Liste des compétences</p>
            </div>

            <DialogRoot>
                <DialogTrigger>
                    <button className="flex items-center gap-x-3 py-3 px-8 rounded-xl text-white font-light bg-[#3c41e9]">
                        <Plus :size="16" strokeWidth="1.3"/>
                        <span>Ajouter une compétence</span>
                    </button>
                </DialogTrigger>
                <DialogPortal>
                    <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
                    <DialogContent className="fixed text-black p-0 overflow-hidden w-[48%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                        <div class="bg-[#eeeeee] px-5 py-8">
                            <DialogTitle class="font-light">Ajouter une compétence</DialogTitle>
                        </div>
                        <div class="p-5">
                            <div class="flex items-start gap-x-3 w-full">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="title" class="font-extralight">Titre <span class="text-[#f00]">*</span></label>
                                    <input type="text" v-model="formdata.title" name="title" placeholder="Master Génie logiciel" autoComplete="off" class="h-[45px] w-full border rounded-lg p-3"/>
                                </div>
                            </div>

                            <div class="flex flex-col gap-1 items-start grow mt-4">
                                <label htmlFor="formation" class="font-extralight">Sélectionner le type<span class="text-[#f00]">*</span></label>
                                <div class="w-full">
                                    <select v-model="formdata.type" name="formation" id="formation" class="w-1/2 min-h-[45px] border rounded-lg">
                                        <option >Selectionner le type</option>
                                        <option value="skill">
                                            Compétence
                                        </option>
                                        <option value="certification">
                                            Certificat
                                        </option>
                                        <option value="degree">
                                            Diplôme
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="description" class="font-extralight">Description <span class="text-[#f00]">*</span></label>
                                    <textarea name="description" v-model="formdata.description" placeholder="Université d'Abidjan" autoComplete="off" class="min-h-[100px] border rounded-lg p-3 w-full"></textarea>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="debut" class="font-extralight">Début <span class="text-[#f00]">*</span></label>
                                    <div class="w-full">
                                        <input type="date" v-model="formdata.start" name="debut" placeholder="" autoComplete="off" class="h-[45px] border rounded-lg p-3 cursor-pointer w-full"/>
                                    </div>
                                </div>
                                <div class="flex flex-col gap-1 items-start grow">
                                    <label htmlFor="fin" class="font-extralight">Fin <span class="text-[#f00]">*</span></label>
                                    <div class="w-full">
                                        <input type="date" name="fin" v-model="formdata.end" placeholder="" autoComplete="off" class="h-[45px] border rounded-lg p-3 cursor-pointer w-full"/>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-start gap-x-3 w-full mt-4">
                                <div class="flex flex-col gap-1 items-start grow">
                                    <span class="font-extralight">Fichier</span>
                                    <div class="flex items-center justify-between w-full">
                                        <label htmlFor="fichier" class="font-extralight h-[45px] w-[49%] hover:bg-[#f1f1f1] transition-all cursor-pointer flex items-center justify-center rounded-lg border border-dashed">
                                            Charger un fichier
                                        </label>
                                        <div class="flex items-center justify-center h-full font-light w-[49%]">
                                            <span v-if="!file">Aucun fichier charger</span>
                                            <span v-else>Un fichier charger</span>
                                        </div>
                                    </div>
                                    <div class="w-full">
                                        <input type="file" v-on:change="selectFiles" accept="image/*,.pdf" name="fichier" id="fichier" placeholder="" autoComplete="off" class="h-[45px] hidden"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="h-[1px] w-full bg-[#ccc]" />
                        <div class="flex items-center justify-end px-5 py-5 gap-x-5">
                            <DialogClose as-child>
                                <button type="button" class="border py-3 px-8 rounded-md">
                                    Fermer
                                </button>
                            </DialogClose>
                            <button v-on:click="addFormation" :disabled="asSend" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-else>Enregistrer</span>
                            </button>
                        </div>
                    </DialogContent>
                </DialogPortal>
            </DialogRoot>
        </div>
        <div class="py-[16px] flex flex-col items-start gap-y-[8px]">
            <template v-if="!load">
                <template v-if="formation.length == 0">
                    <div class="h-[70vh] w-full flex items-center justify-center">
                        <p class="font-extralight">Aucune compétence enregistré</p>
                    </div>
                </template>
                <template v-else>
                    <div v-for="value in formation" :key="value.id" class="w-full p-[8px] mb-[8px]">
                        <div class="flex items-center gap-x-[16px] mb-[8px]">
                            <div class="flex items-center border-[3px] border-white justify-center bg-[#0c5ccf] size-[25px] rounded-full">
                                <Check color="#ffffff" :size="16" strokeWidth="1.5"/>
                            </div>
                            <div class="font-light flex items-center gap-x-[16px]">
                                <span class="font-extralight">{{ value.end ? formatDate2(value.start+"T"+(value.end)) : formatDate(value.start) + " à aujourd'hui" }}</span>
                                <span>{{ "          " }}</span>
                                <span>{{ value.title }} ({{ value.type }})</span>
                            </div>
                        </div>
                        <div class="font-light pl-[41px]">
                            <p class="mb-[8px]">{{ value.description }}</p>
                            <p class="underline" v-on:click="downloadFile('https://backend-ehr.iugb-ci.com/public/image/'+value.file)">{{ value.file }}</p>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="flex flex-col gap-y-[16px] w-full">
                    <div v-for="(_,idx) in Array(3).fill(1)" :key="idx" class="animate-pulse w-full">
                        <div class="flex items-center gap-x-[16px] mb-[8px]">
                            <div class="size-[25px] rounded-full bg-gray-100"/>
                            <div class="h-[25px] w-full rounded-xl bg-gray-100"/>
                        </div>
                        <div class="w-full pl-[41px]">
                            <div class="h-[25px] w-full rounded-xl mb-[8px] bg-gray-100"/>
                            <div class="h-[25px] w-full rounded-xl mb-[8px] bg-gray-100"/>
                            <div class="h-[55px] w-full rounded-xl bg-gray-100"/>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import { advancedFormat,convertirDateEnFrancais } from '@/utils/date-format';
import { Plus,Check
    // Loader2,Trash2 
} from 'lucide-vue-next';
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue';
export default {
    name: "UserCompetence",
    components:{
        // Calendar,
        // Loader2,
        // Trash2,
        Check,
        DialogClose,
        DialogContent,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger,
        Plus
    },
    mounted(){
        this.getAllDegree()
    },
    data(){
        return {
            load: true,
            asSend: false,
            formation: [],
            file:null,
            formdata: {
                title:"",
                description:"",
                type: null,
                start: null,
                end: null
            }
        }
    },
    methods:{
        clearForm(){
            this.formdata = {
                title:"",
                description:"",
                type: null,
                start: null,
                end: null
            }
            this.file = null;
        },
        selectFiles(e){
            if (!e.target.files[0]) return;
            this.file = e.target.files[0];
        },
        getAllDegree(){
            API.get("degrees")
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                this.formation = response.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.load = false;
            })
        },
        addFormation(){
            this.asSend = true;
            const {title,description,type,start,end} = this.formdata;
            const formData = new FormData();
            formData.append("title",title);
            formData.append("description",description);
            formData.append("type",type);
            formData.append("start",start);
            formData.append("end",end);
            formData.append("file",this.file);
            formData.append("user_id",localStorage.getItem("userId"));
            API.post("degrees",formData)
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                  this.getAllDegree();
                  this.clearForm();
                  Swal.fire('Succès',"Compétence enregistré",'succes');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend = false;
            });
        },
        removeFormation(id){
            API.delete("degrees/"+id)
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                    this.getAllDegree();
                    Swal.fire('Succès',"Formation supprimé",'succes');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        formatDate(date){return convertirDateEnFrancais(date)},
        formatDate2(date){
            const [date1,date2] = date.split('T');
            return advancedFormat(date1,date2);
        },
        downloadFile(link){
            fetch(link).then(response => response.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = this.getFileName(link);
                a.click();
                URL.revokeObjectURL(url);
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        }
    }
}
</script>